import React from "react";
import { Link } from "react-router-dom";

// Minimal [label](url) inline-link syntax, mirroring the backend SSR
// renderer (renderer.py::_rich_text). Internal urls hydrate as router
// <Link>s; external urls open in a new tab with rel protection.
const MD_LINK_RE = /\[([^\]]+)\]\((\/[^)\s]*|https?:\/\/[^)\s]+)\)/g;

export function richText(text) {
  if (typeof text !== "string" || text.indexOf("](") === -1) return text;
  const out = [];
  let pos = 0;
  let m;
  MD_LINK_RE.lastIndex = 0;
  while ((m = MD_LINK_RE.exec(text)) !== null) {
    if (m.index > pos) out.push(text.slice(pos, m.index));
    const [, label, url] = m;
    if (url.startsWith("/")) {
      out.push(<Link key={`${m.index}-${url}`} to={url}>{label}</Link>);
    } else {
      out.push(
        <a key={`${m.index}-${url}`} href={url} target="_blank" rel="noopener noreferrer">{label}</a>
      );
    }
    pos = m.index + m[0].length;
  }
  if (pos < text.length) out.push(text.slice(pos));
  return out;
}

function DataTable({ table }) {
  return (
    <figure className="gw-table-wrap" data-testid="prose-data-table">
      <table>
        {table.caption && <caption>{table.caption}</caption>}
        {table.columns?.length > 0 && (
          <thead>
            <tr>{table.columns.map((c, i) => <th scope="col" key={i}>{c}</th>)}</tr>
          </thead>
        )}
        <tbody>
          {table.rows?.map((row, ri) => (
            <tr key={ri}>{row.map((cell, ci) => <td key={ci}>{richText(String(cell))}</td>)}</tr>
          ))}
        </tbody>
      </table>
      <style>{`
        .gw-table-wrap { margin: var(--gw-space-6) 0; overflow-x: auto; }
        .gw-table-wrap table { width: 100%; border-collapse: collapse; font-size: 0.92rem; }
        .gw-table-wrap caption { caption-side: top; text-align: left; font-family: var(--gw-font-serif); font-weight: 600; color: var(--gw-primary-dark); padding-bottom: var(--gw-space-3); }
        .gw-table-wrap th { background: var(--gw-primary); color: #FFF9E8; text-align: left; padding: 10px 14px; font-weight: 600; }
        .gw-table-wrap td { border-bottom: 1px solid var(--gw-border); padding: 10px 14px; vertical-align: top; }
        .gw-table-wrap tbody tr:nth-child(even) { background: #FAF6EC; }
      `}</style>
    </figure>
  );
}

export default function ProseBlock({ section }) {
  const ListTag = section.ordered ? "ol" : "ul";
  return (
    <div className="gw-prose" style={{maxWidth: 780}}>
      {section.heading && <h2>{section.heading}</h2>}
      {section.paragraphs?.map((p, i) => <p key={i}>{richText(p)}</p>)}
      {section.table && <DataTable table={section.table} />}
      {section.bullets && (
        <ListTag>{section.bullets.map((b, i) => <li key={i}>{richText(b)}</li>)}</ListTag>
      )}
    </div>
  );
}
